export const FEATURE_FLAGS = {
  enableFleetConfigurationAssetNga: "enableFleetConfigurationAssetNga",
  enableFleetConfigurationAssetTableImages:
    "enableFleetConfigurationAssetTableImages",
  enableFleetConfigurationBulkAssetIngress:
    "enableFleetConfigurationBulkAssetIngress",
  enableFleetConfigurationBulkEnrichment:
    "enableFleetConfigurationBulkEnrichment",
  enableFleetConfigurationDeviceOnboarding:
    "enableFleetConfigurationDeviceOnboarding",
  enableFleetConfigurationInlineEditCategoriesAndClasses:
    "enableFleetConfigurationInlineEditCategoriesAndClasses",
  enableFleetConfigurationInlineEditGroups:
    "enableFleetConfigurationInlineEditGroups",
  enableFleetConfigurationPimEnrolled: "enableFleetConfigurationPimEnrolled",
  enableFleetConfigurationUnifiedResourceManagement:
    "enableFleetConfigurationUnifiedResourceManagement",
  enableFleetConfigurationUrmAssetsAllocation:
    "enableFleetConfigurationUrmAssetsAllocation",
  enableFleetConfigurationUrmTableGrouping:
    "enableFleetConfigurationUrmTableGrouping",
  enableFleetConfigurationMatchedAssets:
    "enableFleetConfigurationMatchedAssets",
  enableFleetConfigurationNlpAssetSearch:
    "enableFleetConfigurationNlpAssetSearch",
  enableFleetConfigurationAssetEditV2: "enableFleetConfigurationAssetEditV2",
  enableFleetConfigurationAssetResourcesV2:
    "enableFleetConfigurationAssetResourcesV2",
  enableFleetConfigurationOrgUnitReportingDesignation:
    "enableFleetConfigurationOrgUnitReportingDesignation",
};

// flags maintained by other teams but used by us
export const OTHER_FEATURE_FLAGS = {
  enableFleetMapV2PimPocFilters: "enableFleetMapV2PimPocFilters",
  enableResourceMapLocationEnabledBranches:
    "enableResourceMapLocationEnabledBranches",
  enableCompanyOperatorUi: "enableCompanyOperatorUi",
};

export type FleetConfigurationFeatureFlags = typeof FEATURE_FLAGS;
export type OtherFeatureFlags = typeof OTHER_FEATURE_FLAGS;
export type AllFeatureFlags = FleetConfigurationFeatureFlags &
  OtherFeatureFlags;
